import React, { useEffect } from 'react';
import ReactRouter from './Router';
import { Provider } from 'react-redux';
import store from './store/index';
import 'semantic-ui-less/semantic.less';
import * as amplitude from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import {
    Chart as ChartJS,
    BarElement,
    Tooltip,
    Legend,
    defaults,
    Title,
    CategoryScale,
    LinearScale,
    TimeScale,
    PointElement,
    LineElement,
    ArcElement,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ReviewReportProvider } from 'contexts/ReviewReportContext';
import { DailyReportsProvider } from 'contexts/DailyReportContext';
import { TeamProvider } from 'contexts/TeamContext';
import { ToastProvider } from 'contexts/ToastContext';
import ToastContainer from 'components/Toast/ToastContainer';
import StagingBanner from 'components/StagingBanner/StagingBanner';

ChartJS.register(
    BarElement,
    PointElement,
    LineElement,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    CategoryScale,
    LinearScale,
    TimeScale,
    ChartDataLabels
);

function App() {
    amplitude.init('3f35d24e7bad739eee486cbe3da4a5a6', { defaultTracking: true });
    amplitude.add(engagementPlugin());

    useEffect(() => {
        // Chart js default config:
        defaults.font.family = "'Outfit', 'Helvetica Neue', Arial, Helvetica, sans-serif";
        defaults.responsive = true;
        defaults.elements.bar.borderRadius = 1;
        defaults.elements.line.tension = 0.2;
        defaults.scales.linear.grid = {
            ...defaults.scales.linear.grid,
            display: false,
            drawBorder: false,
        };
        defaults.scales.category.grid = {
            ...defaults.scales.category.grid,
            display: false,
            drawBorder: false,
        };
        defaults.plugins.legend.display = false;
        defaults.plugins.tooltip = {
            ...defaults.plugins.tooltip,
            boxPadding: 6,
            padding: 8,
            cornerRadius: 8,
            titleFont: { ...defaults.plugins.tooltip.titleFont, size: 16 },
            bodyFont: { ...defaults.plugins.tooltip.bodyFont, size: 14 },
            itemSort: (a, b) => b.datasetIndex - a.datasetIndex,
        };
        if (defaults.plugins.datalabels) defaults.plugins.datalabels.display = false;
    }, [defaults]);

    return (
        <Provider store={store}>
            <ToastProvider>
                <ReviewReportProvider>
                    <DailyReportsProvider>
                        <TeamProvider>
                            <StagingBanner />
                            <ToastContainer />
                            <ReactRouter />
                        </TeamProvider>
                    </DailyReportsProvider>
                </ReviewReportProvider>
            </ToastProvider>
        </Provider>
    );
}

export default App;
